'use client'

import React, { FC, ReactElement } from 'react'
import classNames from 'classnames'

const RankPill: FC<{ className?: string; rank?: number }> = (props): ReactElement => {
	if (true || !props?.rank) {
		return <div />
	}

	return (
		<div
			className={classNames(
				{ [(props?.className as any)]: !!props?.className },
				'rounded-full h-5 px-3 bg-white/30 backdrop-blur flex items-center justify-center text-xs font-semibold'
			)}
		>{`Rank #${props?.rank}`}</div>
	)
}

export default RankPill
